import React from "react";
import ContactMessages from "./ContactMessages";

const ContactMessagesPage: React.FC = () => {
  return <ContactMessages />;
};

export default ContactMessagesPage;
